if (!customElements.get('sticky-atc')) {
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-sticky-variants]')?.textContent || '[]');
      this.button = this.querySelector('[data-sticky-button]');
      this.label = this.querySelector('[data-sticky-label]');
      this.footer = document.querySelector('footer, .shopify-section-group-footer-group');

      this.onScroll = this.onScroll.bind(this);
      // On desktop Horizon scrolls inside .page-wrapper rather than the window, so listen in the capture phase.
      document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
      window.addEventListener('resize', this.onScroll);
      this.button?.addEventListener('click', () => this.addToCart());

      // Keep the bar in sync with the variant chosen in the main product form.
      this.observer = new MutationObserver(() => this.syncVariant());
      this.watchForm();
      document.addEventListener('change', () => setTimeout(() => this.syncVariant(), 50));

      this.onScroll();
    }

    disconnectedCallback() {
      document.removeEventListener('scroll', this.onScroll, { capture: true });
      window.removeEventListener('resize', this.onScroll);
      this.observer?.disconnect();
    }

    get mainButton() {
      return document.querySelector('.product-information add-to-cart-component button[name="add"], add-to-cart-component button[name="add"]');
    }

    get idInput() {
      return document.querySelector('.product-information form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] input[name="id"]');
    }

    watchForm() {
      const form = this.idInput?.closest('form');
      if (form) this.observer.observe(form, { attributes: true, subtree: true, attributeFilter: ['value'] });
    }

    onScroll() {
      const main = this.mainButton;
      if (!main) return;
      const passed = main.getBoundingClientRect().bottom < 0;
      let footerVisible = false;
      if (this.dataset.hideNearFooter === 'true' && this.footer) {
        const rect = this.footer.getBoundingClientRect();
        footerVisible = rect.top < window.innerHeight && rect.bottom > 0;
      }
      this.classList.toggle('is-visible', passed && !footerVisible);
    }

    syncVariant() {
      const id = Number(this.idInput?.value);
      const variant = this.variants.find((v) => v.id === id);
      if (!variant || variant.id === this.currentId) return;
      this.currentId = variant.id;

      const set = (selector, fn) => { const el = this.querySelector(selector); if (el) fn(el); };
      set('[data-sticky-variant]', (el) => (el.textContent = variant.title));
      set('[data-sticky-price]', (el) => {
        el.textContent = variant.price;
        el.classList.toggle('sticky-atc__price--sale', Boolean(variant.compare));
      });
      set('[data-sticky-compare]', (el) => {
        el.textContent = variant.compare || '';
        el.hidden = !variant.compare;
      });
      set('[data-sticky-badge]', (el) => {
        el.textContent = el.textContent.replace(/\d+/, variant.save);
        el.hidden = !variant.save;
      });
      set('.sticky-atc__img', (el) => {
        if (!variant.image) return;
        el.removeAttribute('srcset');
        el.src = variant.image;
      });

      this.button.disabled = !variant.available;
      if (this.label && !this.button.classList.contains('is-added')) {
        this.label.textContent = variant.available ? this.dataset.buttonLabel : this.mainButton?.textContent.trim() || '';
      }
    }

    addToCart() {
      const main = this.mainButton;
      if (!main || this.button.classList.contains('is-loading')) return;

      this.button.classList.add('is-loading');
      this.button.disabled = true;
      main.click();

      const done = (added) => {
        this.button.classList.remove('is-loading');
        this.button.disabled = false;
        if (!added) return;
        this.button.classList.add('is-added');
        if (this.label) this.label.textContent = this.dataset.addedLabel;
        setTimeout(() => {
          this.button.classList.remove('is-added');
          if (this.label) this.label.textContent = this.dataset.buttonLabel;
        }, 2000);
      };

      const watcher = new MutationObserver(() => {
        if (main.closest('[data-added="true"]') || main.getAttribute('data-added') === 'true') {
          watcher.disconnect();
          clearTimeout(fallback);
          done(true);
        }
      });
      watcher.observe(main.closest('add-to-cart-component') || main, { attributes: true, subtree: true, attributeFilter: ['data-added'] });
      document.addEventListener('cart:update', () => { watcher.disconnect(); clearTimeout(fallback); done(true); }, { once: true });
      const fallback = setTimeout(() => { watcher.disconnect(); done(false); }, 2500);
    }
  }

  customElements.define('sticky-atc', StickyAtc);
}
